var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{staticClass:"indeterminate-progress-circular mr-2",attrs:{"color":"white","size":"20","width":"10","rotate":_vm.rotate,"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }